export default __webpack_public_path__ + "static/media/317.996e9b61.gif";